<template>
  <div class="error-page-container">
    <div class="error-card">
      <!-- 错误图标 -->
      <div class="error-icon">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <!-- 错误标题 -->
      <h2 class="error-title">当前设备不支持访问本网站</h2>
      <div class="error-message">
        <p>温馨提示:</p>
        <p class="tip-item">1. 移动端请关注微信公众号或者下载APP进行学习</p>
        <p class="tip-item">
          2. 如要访问本网站，请使用
          <span style="color: red;">电脑（PC）端浏览器</span>
        </p>
        <p style="text-align: center;">感谢您的理解与配合</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data() {
    return {
      screenWidth: 0, // 设备屏幕宽度
      screenHeight: 0, // 设备屏幕高度
    };
  },
  mounted() {
    // 初始化获取屏幕尺寸
    this.getScreenSize();
    // 监听屏幕尺寸变化（适配旋转屏幕等场景）
    window.addEventListener('resize', this.getScreenSize);
  },
  beforeDestroy() {
    // 移除监听，避免内存泄漏
    window.removeEventListener('resize', this.getScreenSize);
  },
  methods: {
    // 获取设备屏幕宽高
    getScreenSize() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      // 动态设置容器高度为屏幕高度，确保垂直居中
      const container = document.querySelector('.error-page-container');
      if (container) {
        container.style.minHeight = `${this.screenHeight}px`;
      }
    },
  },
};
</script>

<style scoped>
/* 页面容器 - 居中全屏 */
.error-page-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  padding-top: 300px;
  /* align-items: center; */
  /* padding: 20px 16px; */
  margin: 0;
  justify-content: center;
  background-color: #f7f8fc;
  box-sizing: border-box;
}

/* 错误卡片 */
.error-card {
  background: #ffffff;
  padding: 32px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  width: 100%;
  max-width: 500px;
  animation: fadeIn 0.5s ease forwards;
  box-sizing: border-box;
}

/* 错误图标 */
.error-icon {
  color: #f56c6c;
  margin-bottom: 20px;
  display: inline-block;
  transform: scale(0.9); /* 图标响应式缩放 */
}

/* 标题 */
.error-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 700;
  padding: 0 10px;
}

/* 提示文字 */
.error-message {
  font-size: 14px;
  color: #666666;
  line-height: 1.8;
  margin: 0 auto;
  max-width: 90%;
  text-align: left;
  padding: 0 10px;
}
.tip-item {
  margin: 0 0 8px 0;
  padding-left: 24px;
  word-break: break-all;
  white-space: normal;
}

/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配 - 不同屏幕尺寸微调 */
@media (min-width: 768px) {
  .error-icon {
    transform: scale(1); /* 平板/PC恢复图标大小 */
  }
  .error-title {
    font-size: 20px;
  }
  .error-message {
    font-size: 16px;
    max-width: 85%;
  }
  .error-card {
    padding: 40px 30px;
    max-width: 550px;
  }
}

@media (min-width: 1024px) {
  .error-card {
    padding: 40px 60px;
    max-width: 800px;
  }
  .error-message {
    max-width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/errorTips/index.vue